// Auto-generated from gen_ce_info_and_maps.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { CeInfoType } from '../types/ce';

const data: CeInfoType = {
  'AFamiliarFace': {
    'directorId': '212',
    'name': {
      'cn': '复制统治者——第四军团哈修马利姆',
      'de': 'Hashmallim der Einiger',
      'en': 'A Familiar Face',
      'fr': 'Le Grand Ordonnateur',
      'ja': '模造統制者「IVレギオン・ハシュマリム」',
      'ko': '모조 통제자 \'IV군단 하쉬말림\'',
      'tc': '複製統治者——第四軍團赫修馬倫',
    },
  },
  'FeelingTheBurn': {
    'directorId': '20E',
    'name': {
      'cn': '试制型飞行型魔导装甲——黑色燃焰',
      'de': 'Schwarzbrands Testflug',
      'en': 'Feeling the Burn',
      'fr': 'On arrête le progrès',
      'ja': '試作飛行型魔導アーマー「ブラックバーン」',
      'ko': '시험작 비행형 마도 아머 \'블랙번\'',
      'tc': '試製性飛行魔導裝甲——黑色燃焰',
    },
  },
  'FromBeyondTheGrave': {
    'directorId': '21B',
    'name': {
      'cn': '复制告密者——第四军团谢米哈扎',
      'de': 'Shemhazai der Verräter',
      'en': 'From Beyond the Grave',
      'fr': 'Le Sycophante',
      'ja': '模造密告者「IVレギオン・シュミハザ」',
      'ko': '모조 밀고자 \'IV군단 셰미하자\'',
      'tc': '複製告密者——第四軍團謝米哈扎',
    },
  },
  'HeadOfTheSnake': {
    'directorId': '21E',
    'name': {
      'cn': '第四军团军政官——梅内纽斯',
      'de': 'Menenius, Tribunus der IV. Legion',
      'en': 'Head of the Snake',
      'fr': 'Mener par l\'exemple',
      'ja': '第IV軍団分遣隊長「メネニウス」',
      'ko': '제IV군단 분견대장 \'메네니우스\'',
      'tc': '第四軍團軍政官——梅內紐斯',
    },
  },
  'HereComesTheCavalry': {
    'directorId': '21C',
    'name': {
      'cn': '钢铁人马——魔导骑兵大队',
      'de': 'Halb Pferd, halb Garlear',
      'en': 'Here Comes the Cavalry',
      'fr': 'Un cavalier qui surgit hors de la nuit',
      'ja': '鋼鉄の人馬「魔導騎兵大隊」',
      'ko': '강철의 인마 \'마도기병대대\'',
      'tc': '鋼鐵人馬——魔導騎兵大隊',
    },
  },
  'LeanMeanMagitekMachines': {
    'directorId': '218',
    'name': {
      'cn': '新兵器投入——机甲百人队',
      'de': 'Die Gepanzerte Zenturie',
      'en': 'Lean, Mean, Magitek Machines',
      'fr': 'Réusinage de code',
      'ja': '新兵器投入「機甲百人隊」',
      'ko': '신병기 투입 \'기갑백인대\'',
      'tc': '新兵器投入——機甲百人隊',
    },
  },
  'LooksToDieFor': {
    'directorId': '207',
    'name': {
      'cn': '光辉虹蛇——阿依达',
      'de': 'Regenbogenschlange Ayida',
      'en': 'Looks to Die For',
      'fr': 'Écaillage en règle',
      'ja': '輝ける虹蛇「アイダ」',
      'ko': '빛나는 무지개뱀 \'아이다\'',
      'tc': '光輝虹蛇——阿依達',
    },
  },
  'NeverCryWolf': {
    'directorId': '20F',
    'name': {
      'cn': '邪恶冰狼——恶名苍狼',
      'de': 'Eiswolf Hrodvitnir',
      'en': 'Never Cry Wolf',
      'fr': 'Et n\'y Hród\'viens plus !',
      'ja': '邪悪なる氷狼「フローズヴィトニル」',
      'ko': '사악한 얼음늑대 \'흐로드비트니르\'',
      'tc': '邪惡冰狼——惡名蒼狼',
    },
  },
  'OnSerpentsWings': {
    'directorId': '211',
    'name': {
      'cn': '群蛇狂舞——妖战百人队',
      'de': 'Der Geistertrupp',
      'en': 'On Serpents\' Wings',
      'fr': 'Zirnitrop',
      'ja': '妖霊使い「妖戦百人隊」',
      'ko': '요귀술사 \'요전백인대\'',
      'tc': '群蛇狂舞——妖戰百人隊',
    },
  },
  'TakingTheLyonsShare': {
    'directorId': '220',
    'name': {
      'cn': '战栗的百兽之王——兽王莱昂',
      'de': 'Revanche: Lyon der Bestienkönig',
      'en': 'Taking the Lyon\'s Share',
      'fr': 'La revanche de Lyon',
      'ja': '戦慄の百獣使い「獣王ライアン」',
      'ko': '전율하는 백수의 왕 \'마수왕 라이언\'',
      'tc': '戰慄的百獸之王——獸王萊昂',
    },
  },
  'TheBrokenBlade': {
    'directorId': '21F',
    'name': {
      'cn': '惨无人道的强化兵——超级调整兵达波格',
      'de': 'Hyper-Dabog, Stärkster unter Stärksten',
      'en': 'The Broken Blade',
      'fr': 'Dabog l\'hyper-renforcé',
      'ja': '非業の強化兵「ハイパーチューンド・ダボグ」',
      'ko': '비운의 강화병 \'특수강화병 다보그\'',
      'tc': '慘無人道的強化兵——超級調整兵達波格',
    },
  },
  'TheDalriada': {
    'directorId': '213',
    'name': {
      'cn': '旗舰达尔里阿达号攻略战',
      'de': 'Sturm auf die Dalriada',
      'en': 'The Dalriada',
      'fr': 'Assaut sur le Dalriada',
      'ja': '旗艦ダル･リアータ攻略戦',
      'ko': '기함 달리아다 공략전',
      'tc': '旗艦達爾里阿達號攻略戰',
    },
  },
  'ThereWouldBeBlood': {
    'directorId': '210',
    'name': {
      'cn': '异界魔王——汉比',
      'de': 'Hanbi, König im Exil',
      'en': 'There Would Be Blood',
      'fr': 'Le Roi des cendres',
      'ja': '異界の廃王「ハンビ」',
      'ko': '이계의 폐왕 \'한비\'',
      'tc': '異界魔王——漢比',
    },
  },
  'TimeToBurn': {
    'directorId': '21D',
    'name': {
      'cn': '复制魔人——第四军团贝利亚斯',
      'de': 'Dämonid Belias',
      'en': 'Time to Burn',
      'fr': 'Le Titan',
      'ja': '模造魔人「IVレギオン・ベリアス」',
      'ko': '모조 마인 \'IV군단 벨리아스\'',
      'tc': '複製魔人——第四軍團貝利亞斯',
    },
  },
  'WithDiremiteAndMain': {
    'directorId': '221',
    'name': {
      'cn': '焦土魔蝎——赫德提特',
      'de': 'Hedetet, Stachel des Karglands',
      'en': 'With Diremite and Main',
      'fr': 'C\'est dans ma nature',
      'ja': '焦土の魔蠍「ヘデテト」',
      'ko': '초토의 마수 전갈 \'헤데테트\'',
      'tc': '焦土魔蠍——赫德提特',
    },
  },
  'WornToAShadow': {
    'directorId': '222',
    'name': {
      'cn': '有角凶鸟——阿尔科诺斯特',
      'de': 'Alkonost, schrecklich und gefiedert',
      'en': 'Worn to a Shadow',
      'fr': 'Oiseau d\'enfer',
      'ja': '有角の凶鳥「アルコノスト」',
      'ko': '뿔 달린 흉조 \'알코노스트\'',
      'tc': '有角凶鳥——阿爾科諾斯特',
    },
  },
} as const;

export default data;
